var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicineBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01294 12.5132C2.00435 12.3432 2 12.1721 2 12C2 7.43324 5.0612 3.58148 9.24354 2.38474C9.08786 7.01757 6.13099 10.9404 2.01294 12.5132Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20813 14.0392C7.15901 12.3089 10.7169 7.61092 10.7498 2.0774C11.1593 2.02632 11.5766 2 12 2C12.4234 2 12.8407 2.02632 13.2502 2.0774C13.2831 7.61092 16.841 12.3089 21.7919 14.0392C21.4849 15.5209 20.8502 16.8825 19.9668 18.0449C17.7843 16.296 15.0143 15.25 12 15.25C8.98573 15.25 6.21572 16.296 4.03323 18.0449C3.14987 16.8825 2.51509 15.5209 2.20813 14.0392Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9711 19.1696C17.1699 20.9213 14.7109 22 12 22C9.28901 22 6.83002 20.9213 5.02881 19.1696C6.94545 17.6544 9.36708 16.75 12 16.75C14.6329 16.75 17.0545 17.6545 18.9711 19.1696Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7565 2.38474C18.9388 3.58148 22 7.43324 22 12C22 12.1721 21.9957 12.3432 21.9871 12.5132C17.869 10.9404 14.9121 7.01757 14.7565 2.38474Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineBall);
export default __webpack_public_path__ + "static/media/medicine-ball.8b396610442066f18f1a7f0636c49fe8.svg";
export { ForwardRef as ReactComponent };